export default __webpack_public_path__ + "static/media/zapicon_CondominiosSel.e9da2aa5.svg";